<ng-container *ngIf="isDialogOpened">
  <kendo-dialog class="dialog-component app-import-dialog" 
                [title]="dialogTitle"
                (close)="cancel()"
                [minWidth]="250"
                [width]="360"
                [height]="600">
    <div class="dialogContainer">
      <div class="dialogContainerLeft">
        <table aria-hidden="true">
          <tbody>
            <tr *ngIf="importArea === 'ReportValuation'">
              <td class="LabelContainer dialogTableCellPaddingTop">
                <span class="dialogLabel uppercase">{{ 'import.ValuationType' | translate }}</span>
              </td>
            </tr>
            <tr *ngIf="importArea === 'ReportValuation'">
              <td class="FieldContainer">
                <kendo-dropdownlist [data]="valuationTypesOptions"
                                    [textField]="Name"
                                    [valueField]="Oid"
                                    [(ngModel)]="valuationType"></kendo-dropdownlist>
              </td>
            </tr>
            <tr>
              <td class="LabelContainer dialogTableCellPaddingTop">
                <span class="dialogLabel uppercase">{{ 'import.importFile' | translate }}</span>
              </td>
            </tr>
            <tr>
              <td class="FieldContainer">
                <kendo-upload class="upload-component"
                              zoneId="dropZone"
                              [multiple]="true"
                              [saveUrl]="saveUrl"
                              [removeUrl]="uploadRemoveUrl"
                              [restrictions]="restrictions"
                              [autoUpload]="false"
                              (success)="successEventHandler($event)"
                              (upload)="uploadEventHandler($event)">

                  <kendo-upload-messages select="{{selectLabel | translate}}"
                                         cancel="{{cancelLabel | translate}}"
                                         clearSelectedFiles="{{clearSelectedFilesLabel | translate}}"
                                         dropFilesHere="{{dropFilesHereLabel | translate}}"
                                         headerStatusUploaded="{{headerStatusUploadedLabel | translate}}"
                                         headerStatusUploading="{{headerStatusUploadingLabel | translate}}"
                                         invalidFileExtension="{{invalidFileExtensionLabel | translate}}"
                                         invalidMaxFileSize="{{invalidMaxFileSizeLabel | translate}}"
                                         invalidMinFileSize="{{invalidMinFileSizeLabel | translate}}"
                                         remove="{{removeLabel | translate}}"
                                         retry="{{retryLabel | translate}}"
                                         uploadSelectedFiles="{{uploadSelectedFilesLabel | translate}}">
                  </kendo-upload-messages>
                </kendo-upload>
                <div class="dropZoneElement"
                     kendoUploadDropZone="dropZone">
                  <p>Drop files here...</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="dialogButtonBar">
        <div class="ProjectTasksDashboardButtonBarBorder"></div>
        <div class="ButtonBar">
          <button kendoButton class="ButtonWidth_110px" (click)="cancel()">{{ 'cancel2' | translate }}</button>
        </div>
      </div>
    </div>
  </kendo-dialog>
</ng-container>
